import type { DropzoneFile } from '@/shared/ui/components/TruentityDropzone';
import TruentityDropzone from '@/shared/ui/components/TruentityDropzone';
import type { BaseDialogProps } from '@/shared/ui/DialogKit';
import { BaseDialog } from '@/shared/ui/DialogKit';
import { Button, DialogActions, DialogContent } from '@mui/material';
import { useState } from 'react';

type Props = BaseDialogProps & {
  open: boolean;
  onSave: (file: File) => void;
  hideDialog: () => void;
};

const UploadLogoDialog = ({ open, hideDialog, onSave, ...props }: Props) => {
  const [file, setFile] = useState<File[]>([]);

  const handleFiles = (files: DropzoneFile[]) => {
    setFile(files.map(file => file.mediaFile));
  };

  const handleSave = () => {
    onSave(file?.[0]);
    hideDialog();
  };

  return (
    <BaseDialog {...props} title={props.title} open={open} hideDialog={hideDialog} fullWidth={true} maxWidth={'sm'}>
      <DialogContent>
        <TruentityDropzone
          acceptedFiles={[{ files: { 'image/*': ['.jpg', '.jpeg', '.png'] }, maxFileSize: 10 }]}
          onFileUpload={handleFiles}
          onRemoveFile={handleFiles}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={hideDialog}>Cancel</Button>
        <Button onClick={handleSave} variant="contained" color="primary" disabled={file.length <= 0}>
          Save
        </Button>
      </DialogActions>
    </BaseDialog>
  );
};

export default UploadLogoDialog;
